import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import LanguageSwitcher from '../../../components/LanguageSwitcher';

const ResetPasswordForm = ({
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  handleSubmit,
  loading,
}) => {
  const { t } = useTranslation('login');
  const [searchParams] = useSearchParams();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [openLangChange, setOpenLangChange] = useState(false);

  const token = searchParams.get('token');

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };

  const handleLangeChangeClick = () => {
    setOpenLangChange(!openLangChange);
  };

  const handleOutsideClick = (e) => {
    if (!e.target.closest('.change-language')) {
      setOpenLangChange(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  if (!token) {
    return (
      <div className="text-center">
        <h1>{t('INVALIDTOKEN')}</h1>
        <p className="text-muted">{t('INVALIDTOKENMESSAGE')}</p>
        <a href="/forgot-password" className="btn btn-primary">
          {t('REQUESTNEWLINK')}
        </a>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="change-language">
        <LanguageSwitcher
          handleLangeChangeClick={handleLangeChangeClick}
          openLangChange={openLangChange}
          color="white"
        />
      </div>

      <h1>{t('RESETPASSWORD')}</h1>
      <p className="text-center mb-4 text-muted">
        {t('RESETPASSWORDDESCRIPTION')}
      </p>

      <div className="did-floating-label-content mb-4">
        <input
          className="did-floating-input"
          type={showPassword ? 'text' : 'password'}
          name="password"
          id="password"
          placeholder=" "
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="new-password"
        />
        <span className="eye-icon" onClick={togglePasswordVisibility}>
          <img
            src={showPassword ? 'images/eye-change.svg' : 'images/eye.svg'}
            alt={showPassword ? 'Hide Password' : 'Show Password'}
          />
        </span>
        <label className="did-floating-label">{t('NEWPASSWORD')}</label>
      </div>

      <div className="did-floating-label-content mb-4">
        <input
          className="did-floating-input"
          type={showConfirmPassword ? 'text' : 'password'}
          name="confirmPassword"
          id="confirmPassword"
          placeholder=" "
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          autoComplete="new-password"
        />
        <span className="eye-icon" onClick={toggleConfirmPasswordVisibility}>
          <img
            src={
              showConfirmPassword ? 'images/eye-change.svg' : 'images/eye.svg'
            }
            alt={showConfirmPassword ? 'Hide Password' : 'Show Password'}
          />
        </span>
        <label className="did-floating-label">{t('CONFIRMNEWPASSWORD')}</label>
      </div>

      <button
        type="submit"
        disabled={loading}
        className="login btn btn-primary"
      >
        {loading ? t('RESETTING') : t('RESETPASSWORD')}
      </button>

      <div className="text-center mt-3">
        <a href="/login" className="text-decoration-none">
          {t('BACKTOLOGIN')}
        </a>
      </div>
    </form>
  );
};

export default ResetPasswordForm;
